import ApiClient from './ApiClient';

class PurchaseProjectsAPI extends ApiClient {
  constructor() {
    super('purchase_projects', { accountScoped: true });
    this.contactId = null;
  }

  get url() {
    return `${this.baseUrl()}/contacts/${this.contactId}/purchase_projects`;
  }

  get(contactId) {
    this.contactId = contactId;
    return super.get();
  }

  show(contactId, purchaseProjectId) {
    this.contactId = contactId;
    return super.show(purchaseProjectId);
  }

  create(contactId, data) {
    this.contactId = contactId;
    return super.create({ purchase_project: data });
  }

  update(contactId, purchaseProjectId, data) {
    this.contactId = contactId;
    return super.update(purchaseProjectId, { purchase_project: data });
  }

  delete(contactId, purchaseProjectId) {
    this.contactId = contactId;
    return super.delete(purchaseProjectId);
  }
}

export default new PurchaseProjectsAPI();
